import {Request} from "base-app/dist/request";

Request.defaults.baseURL = import.meta.env.VITE_APP_API_URL;
Request.defaults.withCredentials = true;
Request.defaults.withXSRFToken = true;
Request.defaults.xsrfCookieName = 'XSRF-TOKEN';
Request.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
Request.defaults.headers.common.Accept = 'application/json';

export {Request}